import axios from 'axios';
import { combineReducers } from 'redux';

import * as Urls from 'src/constants/EndpointUrls';

import createNamedWrapperReducer from 'src/reducers/createNamedWrapperReducer';
import { itemReducer } from 'src/reducers/common';
// import { setGlobalSuccesses } from 'src/reducers/global';
import { newItem, newItemFailure, editItem, editItemFailure } from 'src/reducers/common/itemReducer';
import { redirectTo } from 'src/utils/Http';
import { scrollToTop } from 'src/utils/Utils';

export const REDUCER_NAME = 'clientProvidentFunds';

export const editClientProvidentFunds = data => async dispatch => {
  try {
    dispatch(editItem(REDUCER_NAME));
    await axios.put(Urls.UPDATE_CLIENT_PROVIDENT_FUND_URL, data);
    redirectTo(Urls.CLIENT_PROVIDENT_FUND_EDIT);
  } catch (exception) {
    scrollToTop();
    dispatch(editItemFailure(REDUCER_NAME, exception.response.data.errors.messages));
  }
};

export default combineReducers({
  item: createNamedWrapperReducer(itemReducer, REDUCER_NAME)
});